/* leitir */
function setja_leit(str_leit,scope)
{
	var leit_str = str_leit.value.trim();
	console.log(encodeURIComponent(leit_str));
	if (leit_str != "" && scope.value == 'safn')
	{
		//window.open("http://leitir.is/primo_library/libweb/action/search.do?&vl(freeText0)=" + encodeURIComponent(leit_str) + "&scp.scps=scope:(REYAS%29&vl%2879520019UI1)&vid=REYNSV&fn=search");
		window.open("https://leitir.is/primo_library/libweb/action/search.do?fn=search&ct=search&initialSearch=true&mode=Basic&tab=default_tab&indx=1&dum=true&srt=rank&vid=REYNSV&frbg=&vl%28freeText0%29=" + encodeURIComponent(leit_str) + "&scp.scps=scope%3A%28REYAS%29");
	}
	if(leit_str != "" && scope.value == 'ICE') {
		//window.open("http://leitir.is/primo_library/libweb/action/search.do?&vl(freeText0)=" + encodeURIComponent(leit_str) + "&vid=ICE&fn=search");
		window.open("https://leitir.is/primo_library/libweb/action/search.do?fn=search&ct=search&initialSearch=true&mode=Basic&tab=default_tab&indx=1&dum=true&srt=rank&vid=REYNSV&frbg=&vl%28freeText0%29=" + encodeURIComponent(leit_str) + "&scp.scps=scope%3A%28GEGNIR%29");
	}
	if(leit_str == "")
	{
		alert ("Sláðu inn leitarorð fyrst");
		document.leit.find_code.focus();
	}

	return true;
}

var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.nav = {
	// Init navigation scripts
	init: function() {
		var $menu = $('#mainmenu');
		var $header = $('#header');
		var $qn = $header.find('#qn ul');

		$menu.find('> a,.level1.children > a').click(function(e) {
			$this = $(this).parent();
			if(!$this.hasClass('hover')) {
				$menu.find('.hover').removeClass('hover');
				$this.addClass('hover');
				$('body').addClass('ddOpen');
			}
			else {
				$menu.find('.hover').removeClass('hover');
				$('body').removeClass('ddOpen');
			}
			$('body.ddOpen').on('click', function (e) {
				if (!$(e.target).parents('#mainmenu').length) {
					$menu.find('.hover').removeClass('hover');
					$('body').removeClass('ddOpen');
				}
			});

			e.preventDefault();
		});

		var $qnFirst = $('<li class="level1 qn" />').append($qn.find('li:first').clone().html());
		var $mQn = $qn.clone().prop('class','mmLevel2');
		$mQn.find('li:first').remove();
		var $qnExtra = $($qnFirst).append($mQn[0].outerHTML);

		$menu.find('.mmLevel1:first').append($qnExtra);
		var $mMenu = $menu.find('.menuWrap').clone().prop('id','mMenu');
		var $mHeader = $header.clone().prop('id', 'mHeader').addClass('fixed');

		$('li', '#divisions').each(function() {
			var $item = $(this).clone();
			var $link = $item.children('a');
			$link.text($link.attr('title'));
			$item.addClass($item.hasClass('selected') ? 'selectedLevel1' : '');
			$mMenu.find('.mmLevel1').append($item);
		});

		$('body').append($mMenu);
		$('body').append($mHeader);

		$('#mMenu').mmenu({
			extensions:['theme-white'],
			offCanvas: {
				position: "right"
			}
		},{
			// configuration
			classNames: {
				fixedElements: {
					fixed:"fixed"
				},
				selected:"active"
			}
		});

		/*var $search = $('#searchBox').clone().prop('id','mSearch');
		$('#mMenu .mm-panels .mm-panel:first .mm-navbar').prepend($search);*/

		site.nav.bind();
	},
	bind: function() {
		// Mobile menu toggle

		$('#mainmenuToggle').click(function(e) {
			/*var menuOpen = $('body').hasClass('mainmenu-open');
			if (!menuOpen) {
				site.window.scrollPosition = $(window).scrollTop();
			}
			site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);*/
			e.preventDefault();
		});

		// Expand in mobile menu
		/*
		$('.expand', '#mMenu').bind('click', function(e) {
			e.preventDefault();

			var $this = $(this);
			var $ul = $this.siblings('ul');

			$ul.toggleClass('hide');
			$this.next().toggleClass('down');
			$this.toggleClass('down');
			e.preventDefault();
		});
		*/
	},
	// Toggle mobile menu
	mobileToggle: function(e, menuOpen, scrollPosition) {
		$('body').toggleClass('mainmenu-open');
		$(this).toggleClass('open');
		if (!menuOpen) {
			$(window).scrollTop(0);
			$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
		}
		else {
			$(window).scrollTop(scrollPosition);
			$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
		}
	},
	// Append language to mobilemenu
	appendLanguage: function() {
		var $divisions = $('.menu', '#divisions');
		var $menu = $('ul.mmLevel1', '#mMenu');

		var $html = $('<li class="ele-language si level1"></li>');
		$divisions.find('li').each(function() {
			var $li = $(this).clone();
			$html.append($li.find('a'));
		});

		$menu.append($html);
	}
};

site.frontpage = {
	init: function() {
		if($('body').hasClass('front') && $('body').hasClass('frontpage')) {
			site.frontpage.evenBox();
			site.frontpage.events();
		}
		if($('body').hasClass('safn') && $('body').hasClass('frontpage')) {
			site.frontpage.potd();
		}
		if($('body').hasClass('red') && $('body').hasClass('frontpage')) {
			site.frontpage.duusBanner();
		}
		if($('body').hasClass('frontpage')) {
			site.frontpage.carousel();
		}
	},
	carousel: function() {
		site.owl.init('#main #hero ul', {
			loop:true,
			nav:true,
			navText:['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
			items: 1
		});
	},
	potd:function() {
		site.owl.init('#main .box_galleryimage .owl-carousel', {
			nav:true,
			navText:['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
			items: 1
		});
	},
	evenBox:function() {
		var $top = $('#main .frontTop');
		var h = 0;
		$top.find('.box_calendar_eventlist').each(function() {
			h += $(this).height();
		});
		$top.find('.box_advert').height(h);
	},
	events:function() {
		var $list = $('#main .eventList .event');
		var $all = $('#main .box_calendar_eventlist .viewAll');
		var $descriptions = $('#main .eventList .event .description');
		$list.click(function(e) {
			$this = $(this);
			if($this.hasClass('hover')) {
				$this.toggleClass('hover');
			}
			else {
				$list.removeClass('hover');
				$this.toggleClass('hover');
			}
			if($(e.target).attr('class') != 'more') {
				e.preventDefault();
			}
		});
		$descriptions.click(function(e) {
			e.stopPropagation();
		});
		$all.click(function(e) {
			$(this).prev().toggleClass('open');
			e.preventDefault();
		});
	},
	duusBanner:function() {
		site.owl.init('#main #owl-hero', {
			nav:true,
			navText:['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
			items: 1
		});
	}
};
site.mailinglist = {
	init: function() {
		var $fm = $('#footerMailinglist');
		if($fm) {
			var inputs = $fm.find('input[type="text"],input[type="email"]');
			var button = $fm.find('input[type="submit"]').addClass('disabled');
			var label = $fm.find('label');
			inputs.focus(function () {
				label.addClass('animated fadeOut');
				button.toggleClass('disabled');
			});
			inputs.focusout(function () {
				if (!inputs.val()) {
					label.removeClass('fadeOut');
					button.toggleClass('disabled');
				}
			});
			if(inputs.val()) {
				label.addClass('animated fadeOut');
				button.removeClass('disabled');
			}
		}
	}
};

function openQn() {
	var $qn = $('#qn');
	$qnFirst = $qn.find('li:first');
	$qnFirst.addClass('first').append('<i class="fa fa-caret-down"></i>');
	$qn.find('li:first').click(function(e) {
		$qn.toggleClass('open');
		e.preventDefault();
	});
}

function checkForm() {
	$contact = $('#footer form');
	$contact.find('input[type=text],select,textarea').each(function() {
		$this = $(this);
		if($this.val()) {
			$this.parents('.elm').find('label').addClass('selected');
		}
	});
}

// Run all the inits \o/
$(function() {
	site.nav.init();
	site.frontpage.init();
	site.mailinglist.init();
	site.owl.init('#reviews > ul', {
		loop:true,
		nav:true,
		navText:["",""],
		items: 1
	});

	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	// Responsive vimeo player
	//var $i = $('iframe', '#center');
	//if ($i.length > 0 && $i.attr('src').indexOf('player.vimeo.com') != -1) {
	//	$i.wrap('<div class="vimeoPlayer"></div>');
	//}

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').bind('click', function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	openQn();
	/*
	$('#footer .sofnFooter').click(function(e) {
		$('html,body').animate({ scrollTop: 0 }, 'slow');
		$('#qn li:first').trigger('click');
	});*/

	var hash = window.location.hash.substring(1);
	if(hash == 'sofn') {
		$('body').scrollTop(0);
		$('#qn li:first').trigger('click');
	}

	$contact = $('#footer form');

	$contact.find('input[type=text],select,textarea').focus(function() {
		$(this).parents('.elm').find('label').addClass('selected');
	});
	$contact.find('input[type=text],select,textarea').focusout(function() {
		$(this).parents('.elm').find('label').removeClass('selected');
		checkForm();
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
